// @flow
import { CATEGORIES } from 'services/actions/categoriesActions';
import type { Action } from 'services/actions/Action.type';
import type { Category } from '../../sharedTypes';

export type CategoriesState = {|
  +categories: Array<Category>,
|};

export const categoriesInitialState = {
  categories: [],
};

export function categoriesReducer(
  state: CategoriesState = categoriesInitialState,
  action: Action
): CategoriesState {
  switch (action.type) {
    case CATEGORIES.RECEIVE_CATEGORIES: {
      const { categories } = action;
      return {
        ...state,
        categories,
      };
    }

    default: {
      return state;
    }
  }
}
